module.exports = __webpack_public_path__ + "static/media/phone-call.b61b5e9e.svg";